import { render, staticRenderFns } from "./Certificatemanagement.vue?vue&type=template&id=3c0a4607&scoped=true&"
import script from "./Certificatemanagement.vue?vue&type=script&lang=js&"
export * from "./Certificatemanagement.vue?vue&type=script&lang=js&"
import style0 from "./Certificatemanagement.vue?vue&type=style&index=0&id=3c0a4607&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0a4607",
  null
  
)

export default component.exports